<div class="row pt-3 pb-5 mx-4">
  <div class="col-md-6">
    <label for="state" class="form-label">{{dropdownLabel}}*</label>
    <p-select appendTo="body" [style]="{ width:'100%' }" inputId="state" [options]="stateOptionsForTab"
      [(ngModel)]="FormModel.selectedState" [placeholder]="'Select ' + dropdownLabel" (onChange)="onStateChange()">
    </p-select>
  </div>

  @if (FormModel.selectedState === 'FailedAttempt' && tabName() !== 'plannedTab') {
  <div class="col-md-6">
    <label for="reason" class="form-label">Reason Code*</label>
    <p-select appendTo="body" [style]="{ width:'100%' }" inputId="reason" [options]="reasonOptions"
      [(ngModel)]="FormModel.selectedReason" placeholder="Select Reason">
    </p-select>
  </div>
  }

  <ng-template #updateStateFooter>
    <button type="button" class="pn-button pn-button-primary pn-button-md" (click)="submitStatusUpdate()"
      [disabled]="!FormModel.selectedState || (FormModel.selectedState === 'FailedAttempt' && !FormModel.selectedReason)">
      Update
    </button>
  </ng-template>
</div>